var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FormattedNumber, useIntl } from 'react-intl';
export var defaultCustomRules = {
    'de-AT': {
        currencyPosition: 'after',
        spaceAroundCurrency: true,
        decimalSeparator: ',',
        groupingSeparator: '.',
    },
    'de-CH': {
        currencyPosition: 'after',
        spaceAroundCurrency: true,
        decimalSeparator: '.',
        groupingSeparator: '',
    },
    'fr-CH': {
        currencyPosition: 'after',
        spaceAroundCurrency: true,
        decimalSeparator: '.',
        groupingSeparator: '',
    },
};
/**
 * Helper function as a sort-of replacement for intl.formatNumber
 *
 * This needs intl passed down because it isn't actually a hook but is supposed to be used inline,
 * which would make it hard to keep the order of hooks consistent
 */
export var formatCurrency = function (currency, value, intl, customRules, locale) {
    if (customRules === void 0) { customRules = defaultCustomRules; }
    var currentLocale = locale !== null && locale !== void 0 ? locale : intl.locale;
    var hasLocaleCustomRule = Object.keys(customRules).includes(currentLocale);
    if (!hasLocaleCustomRule) {
        return intl.formatNumber(value / 100, {
            style: 'currency',
            currency: currency,
        });
    }
    var _a = customRules[currentLocale], spaceAroundCurrency = _a.spaceAroundCurrency, currencyPosition = _a.currencyPosition, decimalSeparator = _a.decimalSeparator, groupingSeparator = _a.groupingSeparator;
    try {
        var numberFormatParts = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency,
        }).formatToParts(value / 100);
        // Intl.Numberformat will simply throw if the currency or locale doesn't make sense
        // It is safe remove the undefined case
        var currencyPart = numberFormatParts.find(function (_a) {
            var type = _a.type;
            return type === 'currency';
        });
        var currencySymbol = currencyPart.value;
        // Only keep the parts we care about
        // We drop the currency here as we handle that differently further down
        numberFormatParts = numberFormatParts.filter(function (_a) {
            var type = _a.type;
            return type === 'group' ||
                type === 'decimal' ||
                type === 'fraction' ||
                type === 'integer' ||
                type === 'minusSign';
        });
        // Update the grouping and decimal separators to the configured values
        numberFormatParts = numberFormatParts.map(function (part) {
            if (part.type === 'group') {
                return __assign(__assign({}, part), { value: groupingSeparator });
            }
            if (part.type === 'decimal') {
                return __assign(__assign({}, part), { value: decimalSeparator });
            }
            return part;
        });
        var currencyspacer = spaceAroundCurrency ? ' ' : '';
        var prefix = '';
        var suffix = '';
        if (currencyPosition === 'before') {
            prefix = "" + currencySymbol + currencyspacer;
        }
        else {
            suffix = "" + currencyspacer + currencySymbol;
        }
        // Turn the number to a string (can't use an actual number because of the custom separators)
        var numberString = numberFormatParts.map(function (_a) {
            var partValue = _a.value;
            return partValue;
        }).join('');
        return "" + prefix + numberString + suffix;
    }
    catch (e) {
        return intl.formatNumber(value / 100, {
            style: 'currency',
            currency: currency,
        });
    }
};
export var FormattedCurrency = function (_a) {
    var currency = _a.currency, value = _a.value, _b = _a.customRules, customRules = _b === void 0 ? defaultCustomRules : _b;
    var intl = useIntl();
    // getUserLocale won't work for the storybook, intl.locale should be good enough here
    var hasLocaleCustomRule = Object.keys(customRules).includes(intl.locale);
    if (!hasLocaleCustomRule) {
        return React.createElement(FormattedNumber, { currency: currency, style: "currency", value: value / 100 });
    }
    return React.createElement(React.Fragment, null, formatCurrency(currency, value, intl, customRules));
};
export default FormattedCurrency;
//# sourceMappingURL=index.js.map